import type { NextPage } from 'next'
import styles from '../../styles/Button.module.scss'
import { Size } from 'types/size'
interface Props {
  text?: string
  type?: string
  size?: Size
  disabled?: boolean
  onClick: any
  children?: JSX.Element
  icon?: JSX.Element
  wide?: boolean
}
const Button: NextPage<Props> = (props: Props) => {
  const type = props.type
  const size = props.size
  const text = props.text
  const onClick = props.onClick
  let className = styles.bg_white
  if (type === '1') className = styles.bg1
  else if (type === '2') className = styles.bg2
  else if (type === '3') className = styles.bg3
  else if (type === '4') className = styles.bg4
  else if (type === '5') className = styles.bg5
  else if (type === '6') className = styles.bg6
  else if (type === '7') className = styles.bg7
  else if (type === '10') className = styles.bg10
  else if (type === '11') className = styles.bg11
  else if (type === '12') className = styles.bg12
  else if (type === 'white') className = styles.bg_white

  const combinedClassNames = [
    className,
    size === Size.small && styles.small,
    size === Size.auto_size && styles.auto_size,
    size === Size.xSmall && styles.xSmall,
    size === Size.xxSmall && styles.xxSmall,
    size === Size.xxxSmall && styles.xxxSmall,
    size === Size.medium && styles.medium,
    size === Size.large && styles.large,
    props.wide && styles.wide,
    props.disabled && styles.disabled,
  ]
    .filter((e) => !!e)
    .join(' ')
  return (
    <button disabled={props.disabled} className={combinedClassNames} onClick={onClick}>
      {props.icon}
      <div className={styles.text}>
        {text}
      </div>
      {props.children}
    </button>
  )
}

export default Button
